import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import CustomButton from "../../custom/custom-button/CustomButton";
import style from "./ConfirmModal.module.scss";

const ConfirmModal = ({
  isOpen,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  isLoading = false,
  isConfirmWhite = false,
  isCancelWhite = true,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className={style.confirmModalOverlay}>
      <div className={style.confirmModal}>
        <p className={style.confirmModal_title}>{title}</p>
        <p className={style.confirmModal_message}>{message}</p>
        <div className={style.confirmModal_actions}>
          <CustomButton
            isWhite={isCancelWhite}
            text={cancelText || t("common.cancel")}
            onClick={onCancel}
            disabled={isLoading}
            isWhiteBox
          />
          <CustomButton
            isWhite={isConfirmWhite}
            text={confirmText || t("common.confirm")}
            onClick={onConfirm}
            isLoading={isLoading}
            isDark
          />
        </div>
      </div>
    </div>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isConfirmWhite: PropTypes.bool,
  isCancelWhite: PropTypes.bool,
};

export default ConfirmModal;
